import providerModuleState from "./providerModule/state";

export default {
  ...providerModuleState,
};
